module.exports = __webpack_public_path__ + "static/img/sf1.102c83f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sf1.png
// module id = xG7B
// module chunks = 1